/** Who is available during timeframe, AI chat or user chat */
export var FrameHandlerType;
(function (FrameHandlerType) {
    /** Unknown frame type. */
    FrameHandlerType["UNKNOWN_FRAME_TYPE"] = "UNKNOWN_FRAME_TYPE";
    /** Frame type not selected. */
    FrameHandlerType["NOT_SELECTED"] = "NOT_SELECTED";
    /** AI Chat available in time frame. */
    FrameHandlerType["AI_CHAT"] = "AI_CHAT";
    /** Chat with human in time frame. */
    FrameHandlerType["WIX_USER_CHAT"] = "WIX_USER_CHAT";
})(FrameHandlerType || (FrameHandlerType = {}));
/** Chat availability options */
export var ChatHandlerMode;
(function (ChatHandlerMode) {
    /** Unknown availability. */
    ChatHandlerMode["UNKNOWN_MODE"] = "UNKNOWN_MODE";
    /** AI assistant is always available. */
    ChatHandlerMode["ALWAYS_WITH_AI"] = "ALWAYS_WITH_AI";
    /** Chat with site owner is always available. */
    ChatHandlerMode["ALWAYS_WITH_WIX_USER"] = "ALWAYS_WITH_WIX_USER";
    /** AI and site owner are available according to schedule. */
    ChatHandlerMode["SCHEDULED"] = "SCHEDULED";
    /** AI assistant and site owner are always offline. */
    ChatHandlerMode["OFF"] = "OFF";
})(ChatHandlerMode || (ChatHandlerMode = {}));
export var OfflineBehavior;
(function (OfflineBehavior) {
    /** Unknown offline behavior. */
    OfflineBehavior["UNKNOWN_OFFLINE_BEHAVIOR"] = "UNKNOWN_OFFLINE_BEHAVIOR";
    /** Allows the site visitor to write messages, but doesn't send a contact form. */
    OfflineBehavior["CHAT_ONLY"] = "CHAT_ONLY";
    /** Hides the AI Site-Chat from the site. */
    OfflineBehavior["HIDE"] = "HIDE";
    /** Doesn't allow the site visitor to write messages, but does send a contact form. */
    OfflineBehavior["CONTACT_FORM_WITHOUT_CHAT"] = "CONTACT_FORM_WITHOUT_CHAT";
    /** Allows the site visitor to write messages and sends a contact form. */
    OfflineBehavior["CONTACT_FORM_WITH_CHAT"] = "CONTACT_FORM_WITH_CHAT";
})(OfflineBehavior || (OfflineBehavior = {}));
export var ChatHandler;
(function (ChatHandler) {
    /** Unknown handler. */
    ChatHandler["UNKNOWN_HANDLER"] = "UNKNOWN_HANDLER";
    /** AI assistant is handling chats. */
    ChatHandler["AI"] = "AI";
    /** Site owner is handling chats. */
    ChatHandler["SITE_OWNER"] = "SITE_OWNER";
})(ChatHandler || (ChatHandler = {}));
//# sourceMappingURL=types.impl.js.map